import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material';
import { AppService } from 'src/app/_service/app.service';
//import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
 user:any = {
  Id:"",
  Password:""
 }
 password: any = {
  OldPassword:"",
  NewPassword:""
 }
  constructor(public dialog: MatDialog, private appService: AppService,
      private router: Router,private route: ActivatedRoute,
    private locationn: Location) {
      const data = JSON.parse(localStorage.getItem('office_q_uid'));
      this.user.Id = data.UserId;
     }

  ngOnInit() {
    this.getCurrentUserPassword();
  }

  getCurrentUserPassword(){
    this.appService.postService({...this.user}, 'UserGetById')
			  .subscribe(response => {
				this.user.Password = response.body.Result.Password;
			  });
  }

  changePassword(){
    if(this.password.OldPassword == this.user.Password){
      this.user.Password = this.password.NewPassword;
      this.appService.postService({...this.user}, 'ChangePassword')
			  .subscribe(response => {
          if (response.body.Success){
            this.router.navigate(['/app/dashboard']);
          }
			  });
    } else{
      //Display error message
      return false;
    }
  }

  goBack(): void{
    this.locationn.back();
  }

}
